<template>
  <div>
    <div class="card mg-b-20">
      <div
        class="card-header d-flex align-items-center justify-content-between"
      >
        <h6 class="mg-b-0">
          {{ b != undefined && b.nm != undefined ? b.nm : "Бие даалт" }}
        </h6>
        <div class="d-flex tx-18">
          <div
            @click="showModal()"
            class="btn btn-xs btn-outline-light mg-l-auto"
          >
            <feather type="send" class="mg-r-5"></feather>илгээх
          </div>
        </div>
      </div>

      <div
        class="pd-x-10 pd-t-10 bg-gray-100"
        v-if="b.attachId != null || b.info != ''"
      >
        <div v-if="b.attachId != null" class="d-flex pd-5">
          <div class="pd-r-5">Файл:</div>
          <a
            @click="$emit('show-attach', b.attachId)"
            class="tx-link-01"
            role="button"
            ><feather type="paperclip" class="mg-r-5"></feather>Файл харах</a
          >
        </div>
        <div v-if="b.info != ''" class="d-flex pd-5">
          <div class="pd-r-5">Тухай:</div>
          <div v-html="b.info"></div>
        </div>
      </div>

      <ul class="list-group list-group-flush" v-if="tasks.length">
        <li
          @click="
            t.attachment != null && t.attachment.id > 0
              ? $emit('show-attach', t.attachment.id)
              : ''
          "
          class="list-group-item list-group-item-action d-flex align-items-center"
          v-for="(t, i) in tasks"
          :key="i"
          :role="
            t.attachment != null && t.attachment.id > 0 ? 'button' : 'default'
          "
        >
          <div class="d-flex">
            <div class="avatar d-none d-sm-block">
              <span
                :class="
                  `avatar-initial rounded-circle ${
                    t.i1 > 0 ? 'bg-teal' : 'bg-gray-400'
                  }`
                "
              >
                <i v-if="t.i1 > 0" class="icon ion-md-checkmark"></i>
              </span>
            </div>
            <div class="pd-l-10">
              <h6 class="tx-13 tx-semibold mg-b-0">{{ t.task }}</h6>
              <span class="d-block tx-11 text-muted">
                {{ t.createdDate | moment("YYYY.MM.DD HH:mm, dddd") }}</span
              >
            </div>
          </div>
          <div class="mg-l-auto text-right">
            <p class="tx-medium text-success font-weight-bold mg-b-0">
              {{ t.i1 }}
            </p>
            <small class="tx-12 mg-b-0">оноо</small>
          </div>
        </li>
      </ul>
      <div v-else class="pd-20 text-center">
        илгээх дарж илгээнэ үү
      </div>

      <div
        v-if="rdy"
        class="card-footer text-center tx-13 d-flex align-items-center"
      >
        <strong>Хүлээн авах хугацаа !</strong>
        <div class="mg-l-auto">
          {{ box.d1 | moment("YYYY.MM.DD HH:mm, dddd") }} -
          {{ box.d2 | moment("YYYY.MM.DD HH:mm, dddd") }}
        </div>
      </div>
    </div>

    <b-modal v-model="modal.show" hide-header hide-footer centered>
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          @click="modal.show = false"
          role="button"
          class="close pos-absolute t-15 r-15"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block">
            <feather type="pen-tool" class="wd-40-f ht-40-f"></feather>
          </span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">Бие даалт илгээх</h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              Тэмдэглэл болон бие даалтын файлаа хуулаад илгээх дарна уу
            </p>
          </div>
        </div>
        <!-- media -->
      </div>
      <!-- modal-header -->
      <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Тэмдэглэл</label
          >
          <input
            v-model="taskModel.task"
            type="text"
            class="form-control"
            maxlength="450"
            placeholder="Тэмдэглэл бичнэ үү"
          />
        </div>

        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Файл</label
          >
          <simple-uploader
            v-model="taskModel.defaultAttachmentId"
            :propObjectTypeId="6"
            @on-success="fileUploaded"
          >
            <div slot="trigger">
              <div
                v-if="taskModel.defaultAttachmentId == null"
                class="btn btn-primary"
                style="height: 38px"
              >
                <label style="margin-btoom: 0" class="custom-file-label"
                  >Файл сонгоогүй байна</label
                >
              </div>
              <div
                v-else
                class="btn d-flex align-items-center btn-outline-success btn-block btn-xs"
                style="height: 38px"
                @click.prevent.stop="taskModel.defaultAttachmentId = null"
              >
                <span class="mg-l-auto d-flex align-items-center text-danger">
                  Болих
                  <feather type="x" class="mg-l-5"></feather>
                </span>
              </div>
            </div>
          </simple-uploader>
        </div>
      </div>
      <!-- modal-body -->
      <div class="modal-footer pd-x-20 pd-y-15">
        <button
          @click="modal.show = false"
          type="button"
          class="btn btn-white"
          data-dismiss="modal"
        >
          Болих
        </button>
        <button @click="postTask" type="button" class="btn btn-primary">
          Илгээх
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
const moment = require("moment");

//import { Notification } from "element-ui";

export default {
  components: {
    //Notification,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    course: {
      type: Object,
      default: () => {}
    },
    b: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      modal: {
        show: false
      },
      taskModel: {},
      projId: null,
      box: {},
      tasks: [],
      rdy: false
    };
  },
  mounted() {
    //console.log("mounted");
    this.fetchData();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    fetchData() {
      //console.log("fetching start")
      let _mdl = {
        userId: this.$store.state.user.userId
      };
      request({
        api: { method: "POST", url: "taskCore/coreBoxInTaskList" },
        data: {
          id:
            this.b != undefined && this.b.id > 0
              ? this.b.id
              : this.$route.params.bid,
          skip: 0,
          size: 100,
          model: _mdl
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //this.b = res.data.box;
          this.box = res.data.box;
          this.tasks = res.data.tasks;
          this.rdy = true;
        }
      });
    },
    init() {
      //console.log("initelchive uuu")
      let _ot = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == this.box.objectTypeId
      );
      if (_ot.length) {
        this.projId = _ot[0].id;
      }

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          boxId: this.box.id,
          parentId: this.course.id,
          objectTypeId: this.box.objectTypeId,
          projectId: this.projId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.taskModel = res.data.task;
          this.modal.show = true;
        }
      });
    },
    showModal() {
      request({
        api: { url: "isintime", method: "get" },
        params: {
          startDate: this.box.d1,
          endDate: this.box.d2
        },
        store: self.$store
      }).then(res => {
        if (res != false) {
          this.init();
        } else {
          this.$bvToast.toast(
            `${moment(this.box.d1).format("YYYY.MM.DD")} - ${moment(
              this.box.d2
            ).format("YYYY.MM.DD")}`,
            {
              title: "Бие даалт илгээх хугацаа",
              autoHideDelay: 5000,
              appendToast: false,
              variant: "warning",
              toaster: "b-toaster-top-right"
            }
          );
        }
      });

      // if (

      //   moment(this.box.d1).isBefore(moment(this.parentTask.date.now)) &&
      //   moment(this.box.d2).isAfter(moment(this.parentTask.date.now))
      // ) {

      // } else {

      //   // Notification.error({
      //   //   title:'Бие даалт илгээх хугацаа',
      //   //   message: `${moment(this.box.d1).format('YYYY.MM.DD')} - ${moment(this.box.d2).format('YYYY.MM.DD')}`,
      //   //   duration: 5000,
      //   //   type: "error",
      //   //   position: "top-right",
      //   //   offset: 50
      //   // });
      // }
    },
    fileUploaded(e) {
      this.taskModel.defaultAttachmentId = e.uploadedAttachmentId;
    },
    postTask() {
      //this.taskModel.organizationTaskId=this.parentTask.id;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: {
          model: this.taskModel
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.modal.show = false;
          this.fetchData();
          //this.$emit("on-reload");
        }
      });
    }
  }
};
</script>

<style></style>
